import { Obj } from '@togglecorp/fujs';

import * as types from '#constants/types';

// INTERFACE

export interface DomainState {
    // Projects page
    projects?: types.Project[];

    // Patients and Project page
    patients?: types.Patient[];
    patientsFilter?: types.PatientsFilter;

    // Hospitals page
    hospitals?: types.Hospital[];
}

// ACTION TYPES

// eslint-disable-next-line import/prefer-default-export
export enum DomainType {
    SET_PROJECTS = 'domain/PROJECTS',
    SET_PATIENTS = 'domain/PATIENTS',
    SET_PATIENTS_FILTER = 'domain/PATIENTS_FILTER',
    SET_HOSPITALS = 'domain/HOSPITALS',
    CLEAR_DATA = 'domain/CLEAR_DATA',
}

// ACTION CREATOR INTERFACE

export interface SetProjectsAction {
    type: typeof DomainType.SET_PROJECTS;
    projects: types.Project[];
}

export interface SetPatientsAction {
    type: typeof DomainType.SET_PATIENTS;
    patients: types.Patient[];
}

export interface SetPatientsFilterAction {
    type: typeof DomainType.SET_PATIENTS_FILTER;
    filters: types.PatientsFilter;
}

export interface SetHospitalsAction {
    type: typeof DomainType.SET_HOSPITALS;
    hospitals: types.Hospital[];
}

export interface ClearDataAction {
    type: typeof DomainType.CLEAR_DATA;
}

export type DomainActionTypes = (
    SetProjectsAction | SetHospitalsAction | SetPatientsAction
    | SetPatientsFilterAction | ClearDataAction
);
